import React from 'react';
import { Link } from 'react-router-dom';

const NotFound = () => (
  <div style={{ textAlign: 'center', marginTop: '2rem' }}>
    <h1>404</h1>
    <p>Página não encontrada.</p>
    <Link to="/">Voltar para a página inicial</Link>
    <p>
      {/* Link para a versão estática, útil em hospedagem estática */}
      <a href="/404.html">Versão estática</a>
    </p>
  </div>
);

export default NotFound;